// Generated by Ktorfit
@file:Suppress("warnings")

package org.mifos.mobile.core.network.services

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import de.jensklingenberg.ktorfit.annotationsAttributeKey
import de.jensklingenberg.ktorfit.converter.TypeData
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.parameter
import io.ktor.client.request.setBody
import io.ktor.client.statement.HttpResponse
import io.ktor.http.HttpMethod
import io.ktor.http.URLBuilder
import io.ktor.http.decodeURLQueryComponent
import io.ktor.http.encodeURLPath
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.Int
import kotlin.Long
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress
import kotlinx.coroutines.flow.Flow
import org.mifos.mobile.core.model.entity.TransactionDetails
import org.mifos.mobile.core.model.entity.accounts.loan.LoanAccount
import org.mifos.mobile.core.model.entity.accounts.loan.LoanWithAssociations
import org.mifos.mobile.core.model.entity.accounts.loan.LoanWithdraw
import org.mifos.mobile.core.model.entity.payload.LoansPayload
import org.mifos.mobile.core.model.entity.templates.loans.LoanTemplate

@OptIn(InternalKtorfitApi::class)
public class _LoanAccountsListServiceImpl(
  private val _ktorfit: Ktorfit,
) : LoanAccountsListService {
  private val _helper: KtorfitConverterHelper = KtorfitConverterHelper(_ktorfit)

  override fun getLoanAccountsDetail(loanId: Long): Flow<LoanAccount>? {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("GET")
        url{
        takeFrom(_ktorfit.baseUrl + "loans/${"$loanId".encodeURLPath()}/")
        } 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<Flow<LoanAccount>?>(),
    )
    return _helper.request(_typeData,_ext)
  }

  override fun getLoanWithAssociations(loanId: Long, associationType: String?): Flow<LoanWithAssociations> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("GET")
        url{
        takeFrom(_ktorfit.baseUrl + "loans/${"$loanId".encodeURLPath()}")
        associationType?.let{ parameter("associations", "$it") }
        } 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<Flow<LoanWithAssociations>>(),
    )
    return _helper.request(_typeData,_ext)!!
  }

  override fun getLoanTemplate(clientId: Long?): Flow<LoanTemplate> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("GET")
        url{
        takeFrom(_ktorfit.baseUrl + "loans/template?templateType=individual")
        clientId?.let{ parameter("clientId", "$it") }
        } 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<Flow<LoanTemplate>>(),
    )
    return _helper.request(_typeData,_ext)!!
  }

  override fun getLoanTemplateByProduct(clientId: Long?, productId: Int?): Flow<LoanTemplate> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("GET")
        url{
        takeFrom(_ktorfit.baseUrl + "loans/template?templateType=individual")
        clientId?.let{ parameter("clientId", "$it") }
        productId?.let{ parameter("productId", "$it") }
        } 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<Flow<LoanTemplate>>(),
    )
    return _helper.request(_typeData,_ext)!!
  }

  override suspend fun createLoansAccount(loansPayload: LoansPayload?): HttpResponse {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("POST")
        url{
        takeFrom(_ktorfit.baseUrl + "loans")
        }
        setBody(loansPayload) 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<HttpResponse>(),
    )
    return _helper.suspendRequest(_typeData,_ext)!!
  }

  override suspend fun updateLoanAccount(loanId: Long, loansPayload: LoansPayload?): HttpResponse {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("PUT")
        url{
        takeFrom(_ktorfit.baseUrl + "loans/${"$loanId".encodeURLPath()}/")
        }
        setBody(loansPayload) 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<HttpResponse>(),
    )
    return _helper.suspendRequest(_typeData,_ext)!!
  }

  override suspend fun withdrawLoanAccount(loanId: Long, loanWithdraw: LoanWithdraw?): HttpResponse {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("POST")
        url{
        takeFrom(_ktorfit.baseUrl + "loans/${"$loanId".encodeURLPath()}?command=withdrawnByApplicant")
        }
        setBody(loanWithdraw) 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<HttpResponse>(),
    )
    return _helper.suspendRequest(_typeData,_ext)!!
  }

  override fun getLoanTransactionDetails(loanId: Long, transactionId: Long): Flow<TransactionDetails> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("GET")
        url{
        takeFrom(_ktorfit.baseUrl + "loans/${"$loanId".encodeURLPath()}/transactions/${"$transactionId".encodeURLPath()}")
        } 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<Flow<TransactionDetails>>(),
    )
    return _helper.request(_typeData,_ext)!!
  }
}

public class _LoanAccountsListServiceProvider : ClassProvider<LoanAccountsListService> {
  override fun create(_ktorfit: Ktorfit): LoanAccountsListService = _LoanAccountsListServiceImpl(_ktorfit)
}

public fun Ktorfit.createLoanAccountsListService(): LoanAccountsListService = _LoanAccountsListServiceImpl(this)
